import { Component, Input, Optional } from '@angular/core';
import { CacheService } from './cache.service';
import { Cache } from './cache.domain';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '../alert/alert.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AbstractSigaleComponent } from '../abstract-sigale.component';
import { finalize } from 'rxjs/operators';
import { isNullOrUndefined } from '../../utils/functions';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';

@Component({
	standalone: true,
	selector: 'cache',
	templateUrl: './cache.component.html',
	styleUrls: ['./cache.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		ToastModule,
		ButtonModule,
		DropdownModule
	]
})
export class CacheComponent extends AbstractSigaleComponent {

	readonly toastKey: string = 'cacheComponentToastKey';

	// Ce tableau de regexes permet de déterminer les caches à exclure de la lecture et la mise à jour.
	// Si un cache vérifie au moins une de ces regexes, il est exclut de la liste.
	@Input("exclusionsCache")
	exclusionsCache: RegExp[] = [/^langue\./]
	loadingIndicator: boolean = false;
	caches: Cache[];
	cache: Cache;
	cacheTous: Cache;

	constructor(@Optional() private route: ActivatedRoute, private cacheService: CacheService, private alertService: AlertService, private messageService: MessageService) {
		super();
		this.cacheTous = new Cache();
		this.cacheTous.cacheName = 'Tous';

		// Pour la gestion des applications qui utilisent le route et celles qui ne l'utilisent pas
		if (this.route?.snapshot?.data && this.route.snapshot.data['appCache']) {
			this.ajouterElements(this.route.snapshot.data['appCache'])
		}
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (isNullOrUndefined(this.caches)) {
			this.lister();
		}
	}

	lister(): void {
		this.loadingIndicator = true;
		(this.modeSigaleBackend1 ? this.cacheService.statistics() : this.cacheService.lister())
			.pipe(finalize(() => this.loadingIndicator = false))
			.subscribe(
				data => this.ajouterElements(data),
				error => this.alertService.error(error.error, this.nomAlert)
			);
	}

	private ajouterElements(caches: Cache[]): void {
		this.caches = caches.filter(cache => !this.estAExclureDuCache(cache)).sort((a1, a2) => a1.cacheName.localeCompare(a2.cacheName));
		this.caches.unshift(this.cacheTous);
		this.cache = this.cacheTous;
	}

	clear(cache: Cache): void {
		let cacheASupprimer: string[];
		if (cache !== this.cacheTous) {
			cacheASupprimer = [cache.cacheName];
		}
		else {
			// On récupère le nom des caches qui ne sont pas exclus de la suppression.
			cacheASupprimer = this.caches.filter(cache => !this.estAExclureDuCache(cache)).map(cache => cache.cacheName)
		}

		this.cacheService.clear(cacheASupprimer)
			.subscribe(
				() => {
					this.lister();
					this.cache = null;
					this.afficherToastSuccess(this.translateService.instant('SIGALE_ANGULAR.COMPONENTS.CACHE.OPERATION_REUSSIE'));
				},
				error => this.alertService.error(error.error, this.nomAlert)
			);
	}

	estAExclureDuCache(cache: Cache): boolean {
		return this.exclusionsCache.some((regex) => regex.test(cache.cacheName));
	};

	afficherToastSuccess(message: string): void {
		this.messageService.add({ key: this.toastKey, severity: 'success', detail: message });
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"CACHE": {
						"CACHE": "Cache",
						"TITRE": "Suppression des caches",
						"BTN_SUPPRIMER": "Supprimer",
						'OPERATION_REUSSIE': 'Opération réussie'
					}
				}
			}
		};
	}

	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"CACHE": {
						"CACHE": "Cache",
						"TITRE": "Cancellazione della cache",
						"BTN_SUPPRIMER": "Cancellare",
						'OPERATION_REUSSIE': 'Operazione riuscita'
					}
				}
			}
		};
	}

}
